import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PIconModule } from '@panaya/ui/p-icon';
import { PActionButtonComponent } from './p-action-button.component';
import { PipeModule } from '@panaya/ui/pipes';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [PActionButtonComponent],
    imports: [CommonModule, PIconModule, PipeModule, MatTooltipModule],
    exports: [PActionButtonComponent]
})
export class PActionButtonModule {}
